import { testId } from '@lojinha/helpers';
import React, { Children } from 'react';
import { Box } from '../Box';
import { Controls } from './controls';
import { useCarousel } from './hook';
import { Container, Slide, Wrapper } from './style';
const getJustifyHeader = (direction) => {
    if (direction === 'left')
        return 'flex-start';
    else if (direction === 'center')
        return 'space-around';
    return 'space-between';
};
export const CarouselUI = ({ children, onChange, id, constrolsOnVertical, constrolsOnHorizontal, slideToShow, header, onNextSlideClick, onPrevSlideClick, }) => {
    const filteredChildren = Children.toArray(children).filter(Boolean);
    const childrenCount = Children.count(filteredChildren);
    const totalPagination = slideToShow
        ? Math.ceil(childrenCount / Math.floor(slideToShow))
        : childrenCount;
    const { goToPrevSlide, goToNextSlide, handlerOnKeyDown, slideActiveIndex, slideWidth, measuredContainerRef, slideIsActive, handlerOnScroll, } = useCarousel({ totalSlides: totalPagination, slideToShow, onChange });
    if (!filteredChildren)
        return null;
    const controlsOnTop = constrolsOnVertical && constrolsOnVertical === 'top';
    return (React.createElement(Wrapper, { className: "carousel" },
        React.createElement(Box, { display: "flex", paddingTop: ['x24', 'x32'], paddingBottom: ['x0', 'x16'], alignItems: "center", justifyContent: controlsOnTop ? getJustifyHeader(constrolsOnHorizontal) : undefined, htmlAttrs: { className: 'header' }, ...testId('carousel-header') },
            header,
            controlsOnTop && (React.createElement(Controls, { activePage: slideActiveIndex, totalPagination: totalPagination, onNextButtonClick: () => {
                    goToNextSlide();
                    onNextSlideClick && onNextSlideClick();
                }, onPrevButtonClick: () => {
                    goToPrevSlide();
                    onPrevSlideClick && onPrevSlideClick();
                }, id: id, direction: constrolsOnHorizontal }))),
        React.createElement(Container, { id: id, onKeyDown: handlerOnKeyDown, "aria-live": "polite", "aria-relevant": "additions", "aria-atomic": true, ref: measuredContainerRef, className: "carousel-container", ...testId('carousel-container'), onScroll: handlerOnScroll },
            React.createElement(Box, { display: "flex", as: "ul", htmlAttrs: { className: 'carousel-tracker' } }, filteredChildren.map((child, i) => (React.createElement(Slide, { key: i, tabIndex: slideIsActive(i) ? 0 : -1, active: slideIsActive(i), slideWidth: slideWidth, className: "slide" }, child))))),
        !controlsOnTop && (React.createElement(Controls, { id: id, activePage: slideActiveIndex, totalPagination: totalPagination, onNextButtonClick: goToNextSlide, onPrevButtonClick: goToPrevSlide, direction: constrolsOnHorizontal }))));
};
CarouselUI.defaultProps = {
    constrolsOnHorizontal: 'right',
    constrolsOnVertical: 'top',
    slideToShow: 1,
};
//# sourceMappingURL=ui.js.map